<template>
  <div class="water_mark_box">
    <!--  左侧文件    -->
    <div class="half_box">
      <div class="contract_div" ref="contractShowBox">
        <img class="img_src" :src="imgSrc" alt="" />
      </div>
      <canvas
        ref="myCanvas"
        width="300"
        height="150"
        style="display: none"
      ></canvas>
      <div class="water_mark"></div>
    </div>
    <!--  右侧    -->
    <div class="half_box">
      <!--   详细设置     -->
      <div class="water_main">
        <!--    1      -->
        <div class="water_text margin_bottom">
          <p class="item_title"><span class="start_color">*</span>水印内容</p>
          <!--   @blur="addWaterMarker"-->
          <el-input
            type="textarea"
            @blur="getWaterMaker"
            placeholder="请输入内容"
            v-model="waterMarkText"
            maxlength="30"
            show-word-limit
            size="small"
          >
          </el-input>
        </div>
        <!--    2      -->
        <ul class="font_color margin_bottom">
          <li class="font_color_li">
            <p class="item_title"><span class="start_color">*</span>字号</p>
            <el-select
              v-model="waterParamObject.intFontSize"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in fontSizeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </li>
          <li class="font_color_li">
            <p class="item_title"><span class="start_color">*</span>颜色</p>
            <el-color-picker
              color-format="rgb"
              v-model="waterParamObject.color"
              :predefine="predefineColors"
              size="small"
            >
            </el-color-picker>
          </li>
        </ul>
        <!--    3     -->
        <div class="transparent_set margin_bottom">
          <p class="item_title"><span class="start_color">*</span>透明度</p>
          <div class="transparent_item block">
            <el-slider
              class="slider_line"
              v-model="waterParamObject.floatAlpha"
              size="small"
            >
            </el-slider>
            <el-select
              v-model="waterParamObject.floatAlpha"
              placeholder="请选择"
              style="width: 120px; margin-left: 20px;"
              size="small"
            >
              <el-option
                v-for="item in transparentOptions"
                :key="item.value"
                :label="item.label + '%'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!--    4      -->
        <div class="water_address margin_bottom">
          <p class="item_title"><span class="start_color">*</span>水印位置</p>
          <ul class="address_ul">
            <li
              v-for="(item, index) in positionList"
              :class="[
                'address_li',
                item.class,
                { active: item.value === waterParamObject.direction }
              ]"
              @click="
                () => {
                  waterParamObject.waterNum = item.value === 0 ? 4 : 2;
                  waterParamObject.direction = item.value;
                }
              "
              :key="index"
            >
              <template v-if="item.value === 0">
                <div
                  class="more_tile_child"
                  v-for="index in 18"
                  :key="index"
                ></div>
              </template>
              <div class="address_child" v-else></div>
            </li>
          </ul>
          <ul class="address_ul">
            <li class="text_li" v-for="item in positionList" :key="item.value">
              {{ item.label }}
            </li>
          </ul>
        </div>
        <!--     5     -->
        <ul class="font_color margin_bottom">
          <li class="font_color_li">
            <p class="item_title"><span class="start_color">*</span>水印角度</p>
            <el-select
              v-model="waterParamObject.intDegree"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in angleOption"
                :key="item.value"
                :label="item.label + '°'"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </li>
          <li class="font_color_li" v-if="waterParamObject.direction === 0">
            <p class="item_title"><span class="start_color">*</span>水印密度</p>
            <el-select v-model="waterParamObject.waterNum" placeholder="请选择" size="small">
              <el-option
                v-for="item in densityOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </li>
        </ul>
        <!--  footer      -->
        <footer class="footer_class">
          <!-- <p class="item_title">
            <span class="start_color">*</span>水印开关&nbsp;&nbsp;
          </p>
          <el-switch
            style="display: block;margin-right:20px"
            v-model="waterConfig.switch"
            active-color="#ccc"
            inactive-color="#1abc9c"
            :active-value="false"
            :inactive-value="true"
          >
          </el-switch> -->
          <!-- <el-button @click="visibleCancle">取消</el-button> -->
          <el-button type="primary" size="small" @click="addWaterSubmit"
            >确定</el-button
          >
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiMethods } from "../../assets/js/http-serve/http-methods";

export default {
  name: "index",
  props: {
    visible: {
      type: Boolean
    },
    waterConfig: {
      type: Object
    }
  },
  data() {
    return {
      waterMarkText: "保密文件",
      //参数对象
      waterParamObject: {
        intFontSize: "15",
        color: "rgb(0,0,0)",
        floatAlpha: 15,
        intDegree: 45,
        waterNum: 4,
        direction: 0,
        switch: false
      },
      imgSrc: "",
      //tab
      editableTabsValue: "2",
      editableTabs: [
        {
          title: "Tab 1",
          name: "1",
          content: "Tab 1 content"
        },
        {
          title: "Tab 2",
          name: "2",
          content: "Tab 2 content"
        }
      ],
      tabIndex: 2,
      //字号
      fontSizeOptions: [],
      //取色
      predefineColors: [
        "#000000",
        "#333333",
        "#555555",
        "#aaaaaa",
        "#c71585",
        "#d9001b",
        "#ff4500",
        "#ff8c00",
        "#ffd700",
        "#90ee90",
        "#95f204",
        "#00ced1",
        "#1e90ff",
        "#0000bf",
        "#8400ff"
      ],
      //透明度条
      transparentOptions: [
        { label: 0, value: 0 },
        { label: 10, value: 10 },
        { label: 15, value: 15 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: 40, value: 40 },
        { label: 50, value: 50 },
        { label: 60, value: 60 },
        { label: 70, value: 70 },
        { label: 80, value: 80 },
        { label: 90, value: 90 },
        { label: 100, value: 100 }
      ],
      //位置列表
      positionList: [
        { label: "平铺", class: "more_tile", value: 0 },
        { label: "左上", class: "left_top", value: 1 },
        { label: "右上", class: "right_top", value: 2 },
        { label: "左下", class: "left_bottom", value: 3 },
        { label: "右下", class: "right_bottom", value: 4 },
        { label: "居中", class: "only_center", value: 5 }
      ],
      // 角度-密度
      angleOption: [
        { label: 0, value: 0 },
        { label: 15, value: 15 },
        { label: 30, value: 30 },
        { label: 45, value: 45 },
        { label: 60, value: 60 },
        { label: 75, value: 75 },
        { label: 90, value: 90 },
        { label: 105, value: 105 },
        { label: 120, value: 120 },
        { label: 135, value: 135 },
        { label: 150, value: 150 },
        { label: 165, value: 165 },
        { label: 180, value: 180 }
      ],
      densityOption: [
        { label: "稀疏", value: 3 },
        { label: "标准", value: 4 },
        { label: "密集", value: 5 }
      ]
    };
  },
  watch: {
    waterParamObject: {
      handler() {
        this.getWaterMaker();
      },
      deep: true
    }
  },
  mounted() {
    this.getWaterMaker();
  },
  methods: {
    handleTabsEdit(targetName, action) {
      if (action === "add") {
        let newTabName = ++this.tabIndex + "";
        this.editableTabs.push({
          title: "New Tab",
          name: newTabName,
          content: "New Tab content"
        });
        this.editableTabsValue = newTabName;
      }
      if (action === "remove") {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }

        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }
    },
    paramCalculation() {
      let param = {
        ...this.waterParamObject,
        waterMarkText: this.waterMarkText,
        switch: this.waterConfig.switch,
      };
      param.floatAlpha = param.floatAlpha / 100;
      let arr = param.color.substr(4, param.color.length - 5).split(",");
      param.r = arr[0].trim();
      param.g = arr[1].trim();
      param.b = arr[2].trim();
      if (param.direction) {
        delete param.waterNum;
      } else {
        delete param.direction;
      }
      return param;
    },
    getWaterMaker() {
      let param = this.paramCalculation();
      ApiMethods.UserTagController.contractWaterMaker(param).then(result => {
        this.imgSrc = "data:image/jpeg;base64," + result.data;
      });
    },
    //水印设置
    addWaterMarker() {
      //
      let can = this.$refs.myCanvas;
      let cans = can.getContext("2d");
      cans.font =
        this.waterParamObject.intFontSize + "px Microsoft JhengHei" ||
        "16px Microsoft JhengHei";
      let textWidth = cans.measureText(this.waterMarkText);
      // can.width = textWidth.width + 40;
      // can.height = this.waterParamObject.waterNum;
      can.width =
        this.$refs.contractShowBox.offsetWidth / this.waterParamObject.waterNum;
      can.height =
        this.$refs.contractShowBox.offsetHeight /
        this.waterParamObject.waterNum;
      cans.clearRect(0, 0, can.width, can.height);
      cans.save();
      cans.globalAlpha = (100 - this.waterParamObject.floatAlpha) / 100; //.5;透明
      cans.translate(can.width / 2, can.height / 2);
      cans.rotate((this.waterParamObject.intDegree * Math.PI) / 180);
      cans.translate(-can.width / 2, -can.height / 2);
      cans.font =
        this.waterParamObject.intFontSize + "px Microsoft JhengHei" ||
        "16px Microsoft JhengHei";
      cans.fillStyle =
        this.waterParamObject.color || "rgba(180, 180, 180, 0.8)";
      cans.textAlign = "left";
      cans.textBaseline = "Middle";
      cans.fillRect(0, 0, can.width, can.height);
      cans.fillText(this.waterMarkText, 20, can.height / 2);
      this.$refs.contractShowBox.style.backgroundImage =
        "url(" + can.toDataURL("image/png") + ")";
      this.$refs.contractShowBox.style.backgroundRepeat =
        this.waterParamObject.direction === 0 ? "repeat" : "no-repeat";
      this.$refs.contractShowBox.style.backgroundPosition = this.positionFn();
      cans.restore();
    },
    //  位置计算
    positionFn() {
      switch (this.waterParamObject.direction) {
        case 0:
          return "0% 0%";
        case 1:
          return "0% 0%";
        case 2:
          return "100% 0%";
        case 3:
          return "0% 100%";
        case 4:
          return "100% 100%";
        case 5:
          return "50% 50%";
      }
    },
    //
    visibleCancle() {
      this.$emit("update:visible", false);
    },
    addWaterSubmit() {
      if (!this.waterMarkText) {
        return this.$message.warning('请输入水印内容')
      } else {
        let param = this.paramCalculation();
        // param = JSON.stringify(param);
        this.$emit("update:waterConfig", param);
        this.$emit('settingWater',{val:Number(param.switch),key:'waterFlag'})
        this.visibleCancle();
      }
    }
  },
  created() {
    for (let i = 15; i < 30; i++) {
      this.fontSizeOptions.push({ label: i, value: "" });
    }
    for (let i = 30; i <= 120; i += 5) {
      this.fontSizeOptions.push({ label: i, value: "" });
    }
    this.waterParamObject.intFontSize = 15;
    const waterConfig = JSON.parse(JSON.stringify(this.waterConfig)) || {};
    if(Object.keys(waterConfig).length > 1){
      Object.assign(this.waterParamObject, waterConfig);
      //为什么1.1， 因为后端数据是0-1， 而显示数据需要0-100（乘以100），初始值是15，1.1不影响初始判断
      if (this.waterParamObject.floatAlpha < 1.1) {
        this.waterParamObject.floatAlpha = this.waterParamObject.floatAlpha * 100
      }
      this.waterMarkText = waterConfig.waterMarkText
    }
  }
};
</script>

<style scoped lang="less">
/**重写 switch 开关 */
/deep/ .el-switch {
  position: relative;
  height: 27px;
  line-height: 27px;
  &.is-checked {
    .el-switch__core {
      // border-color: #41BDA2;
      // background-color: #41BDA2;
      &:after {
        margin-left: -22px;
      }
    }
  }
  .el-switch__label,
  .el-switch__core {
    width: 59px !important;
    height: 28px;
  }
  .el-switch__core {
    border-radius: 4px;
    border: none;
    background: #f1f1f1;
    &::after {
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
      width: 30px;
      height: 26px;
      border-radius: 4px;
      background-image: url("/images/icon/right.png");
      background-size: 100% 100%;
    }
  }
}
/deep/ .el-switch.is-checked {
  .el-switch__core {
    width: 59px;
    border-color: #ccc !important;
    background-color: #ccc !important;
    &::after {
      background-image: url("/images/icon/pass.png");
      background-size: 100% 100%;
      margin-left: -31px;
    }
  }
}
/**重写 switch 开关 */
/deep/ .el-slider__bar {
  background-color: #d9001b;
}

/deep/ .el-slider__button {
  border: 2px solid #d9001b;
  background-color: #d9001b;
}
.water_mark_box {
  display: flex;
  justify-content: space-around;

  .half_box {
    width: 48%;
    max-width: 500px;
    .contract_div {
      /*height: 600px;*/
      border: 1px solid #f0f0f0;
      margin: 10px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .img_src {
        max-width: 80%;
      }
    }

    .item_title {
      .start_color {
        color: #e00064;
      }
    }

    .water_tab {
    }

    .water_main {
      padding: 20px;
      .footer_class {
        padding-top: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .margin_bottom {
        margin-bottom: 20px;
      }

      .font_color {
        display: flex;
        justify-content: flex-start;

        .font_color_li {
          margin-right: 20px;
        }
      }

      .transparent_set {
        .transparent_item {
          display: flex;
          justify-content: space-between;

          .slider_line {
            flex: 1;
          }
        }
      }

      .water_address {
        .address_ul {
          display: flex;
          justify-content: space-between;

          .text_li {
            width: 15%;
            text-align: center;
          }

          .address_li:hover {
            border: 1px solid #d9001b;

            .more_tile_child,
            .address_child {
              background-color: #d9001b;
            }
          }

          .address_li {
            width: 15%;
            /*height: 100px;*/
            height: 1rem;
            border-radius: 4px;
            border: 1px solid #d7d7d7;
            display: flex;
            flex-wrap: wrap;

            &.left_top {
              justify-content: flex-start;
              align-items: flex-start;
            }

            &.left_bottom {
              justify-content: flex-start;
              align-items: flex-end;
            }

            &.right_top {
              justify-content: flex-end;
              align-items: flex-start;
            }

            &.right_bottom {
              justify-content: flex-end;
              align-items: flex-end;
            }

            &.only_center {
              justify-content: center;
              align-items: center;
            }

            .address_child {
              width: 50%;
              height: 20px;
              background-color: #f2f2f2;
            }

            &.more_tile {
              justify-content: space-between;
              align-items: center;
              padding: 8px;
            }

            .more_tile_child {
              width: 30%;
              height: 4px;
              background-color: #f2f2f2;
            }

            &.active {
              border: 1px solid #d9001b;

              .more_tile_child,
              .address_child {
                background-color: #d9001b;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/waterMark/index.vue